// Erzeugt von scripts/fetch-mana-symbols.mjs — nicht von Hand ändern.
import s0 from './T.svg';
import s1 from './Q.svg';
import s2 from './E.svg';
import s3 from './P.svg';
import s4 from './PW.svg';
import s5 from './CHAOS.svg';
import s6 from './A.svg';
import s7 from './TK.svg';
import s8 from './X.svg';
import s9 from './Y.svg';
import s10 from './Z.svg';
import s11 from './0.svg';
import s12 from './HALF.svg';
import s13 from './1.svg';
import s14 from './2.svg';
import s15 from './3.svg';
import s16 from './4.svg';
import s17 from './5.svg';
import s18 from './6.svg';
import s19 from './7.svg';
import s20 from './8.svg';
import s21 from './9.svg';
import s22 from './10.svg';
import s23 from './11.svg';
import s24 from './12.svg';
import s25 from './13.svg';
import s26 from './14.svg';
import s27 from './15.svg';
import s28 from './16.svg';
import s29 from './17.svg';
import s30 from './18.svg';
import s31 from './19.svg';
import s32 from './20.svg';
import s33 from './100.svg';
import s34 from './1000000.svg';
import s35 from './INFINITY.svg';
import s36 from './W-U.svg';
import s37 from './W-B.svg';
import s38 from './B-R.svg';
import s39 from './B-G.svg';
import s40 from './U-B.svg';
import s41 from './U-R.svg';
import s42 from './R-G.svg';
import s43 from './R-W.svg';
import s44 from './G-W.svg';
import s45 from './G-U.svg';
import s46 from './B-G-P.svg';
import s47 from './B-R-P.svg';
import s48 from './G-U-P.svg';
import s49 from './G-W-P.svg';
import s50 from './R-G-P.svg';
import s51 from './R-W-P.svg';
import s52 from './U-B-P.svg';
import s53 from './U-R-P.svg';
import s54 from './W-B-P.svg';
import s55 from './W-U-P.svg';
import s56 from './C-W.svg';
import s57 from './C-U.svg';
import s58 from './C-B.svg';
import s59 from './C-R.svg';
import s60 from './C-G.svg';
import s61 from './2-W.svg';
import s62 from './2-U.svg';
import s63 from './2-B.svg';
import s64 from './2-R.svg';
import s65 from './2-G.svg';
import s66 from './H.svg';
import s67 from './W-P.svg';
import s68 from './U-P.svg';
import s69 from './B-P.svg';
import s70 from './R-P.svg';
import s71 from './G-P.svg';
import s72 from './C-P.svg';
import s73 from './HW.svg';
import s74 from './HR.svg';
import s75 from './W.svg';
import s76 from './U.svg';
import s77 from './B.svg';
import s78 from './R.svg';
import s79 from './G.svg';
import s80 from './C.svg';
import s81 from './S.svg';
import s82 from './L.svg';
import s83 from './D.svg';

const MANA_SYMBOLS = {
  "{T}": s0,
  "{Q}": s1,
  "{E}": s2,
  "{P}": s3,
  "{PW}": s4,
  "{CHAOS}": s5,
  "{A}": s6,
  "{TK}": s7,
  "{X}": s8,
  "{Y}": s9,
  "{Z}": s10,
  "{0}": s11,
  "{½}": s12,
  "{1}": s13,
  "{2}": s14,
  "{3}": s15,
  "{4}": s16,
  "{5}": s17,
  "{6}": s18,
  "{7}": s19,
  "{8}": s20,
  "{9}": s21,
  "{10}": s22,
  "{11}": s23,
  "{12}": s24,
  "{13}": s25,
  "{14}": s26,
  "{15}": s27,
  "{16}": s28,
  "{17}": s29,
  "{18}": s30,
  "{19}": s31,
  "{20}": s32,
  "{100}": s33,
  "{1000000}": s34,
  "{∞}": s35,
  "{W/U}": s36,
  "{W/B}": s37,
  "{B/R}": s38,
  "{B/G}": s39,
  "{U/B}": s40,
  "{U/R}": s41,
  "{R/G}": s42,
  "{R/W}": s43,
  "{G/W}": s44,
  "{G/U}": s45,
  "{B/G/P}": s46,
  "{B/R/P}": s47,
  "{G/U/P}": s48,
  "{G/W/P}": s49,
  "{R/G/P}": s50,
  "{R/W/P}": s51,
  "{U/B/P}": s52,
  "{U/R/P}": s53,
  "{W/B/P}": s54,
  "{W/U/P}": s55,
  "{C/W}": s56,
  "{C/U}": s57,
  "{C/B}": s58,
  "{C/R}": s59,
  "{C/G}": s60,
  "{2/W}": s61,
  "{2/U}": s62,
  "{2/B}": s63,
  "{2/R}": s64,
  "{2/G}": s65,
  "{H}": s66,
  "{W/P}": s67,
  "{U/P}": s68,
  "{B/P}": s69,
  "{R/P}": s70,
  "{G/P}": s71,
  "{C/P}": s72,
  "{HW}": s73,
  "{HR}": s74,
  "{W}": s75,
  "{U}": s76,
  "{B}": s77,
  "{R}": s78,
  "{G}": s79,
  "{C}": s80,
  "{S}": s81,
  "{L}": s82,
  "{D}": s83,
};

export default MANA_SYMBOLS;
